export var batchType = {
  // 代金券
  VOUCHER: 1,
  // 折扣券
  DISCOUNT_COUPON: 4,
  // 兑换券
  EXCHANGE_COUPON: 2
};
export var batchApplyStatus = {
  // 可领取
  AVAILABLE: 1,
  // 已领取
  RECEIVED: 2,
  // 已抢光
  ROBBED: 3
};